/**
 * Changes canvas resolution to fit the canvas element size.
 * @param {HTMLCanvasElement} canvas
 */
export function resize (canvas) {
  let resized = false
  if (canvas.width !== canvas.clientWidth) {
    canvas.width = canvas.clientWidth
    resized = true
  }
  if (canvas.height !== canvas.clientHeight) {
    canvas.height = canvas.clientHeight
    resized = true
  }
  return resized
}

export function getCenteredCoordinates (canvas, event) {
  const { left, top, width, height } = canvas.getBoundingClientRect()
  const offsetX = event.clientX - left
  const offsetY = event.clientY - top
  const x = offsetX - (width >> 1)
  const y = offsetY - (height >> 1)
  return [x, y]
}

export function getNormalizedCoordinates (canvas, event) {
  const [x, y] = getCenteredCoordinates(canvas, event)
  const nx = x / (canvas.clientWidth >> 1)
  const ny = y / (canvas.clientHeight >> 1)
  return [nx, ny]
}

export function isInside (canvas, event) {
  const { left, top, right, bottom } = canvas.getBoundingClientRect()
  return event.clientX > left
      && event.clientX < right
      && event.clientY > top
      && event.clientY < bottom
}

export default {
  resize,
  getCenteredCoordinates,
  getNormalizedCoordinates,
  isInside
}
